import { SEO_DE } from './seo.locale.de.mjs';

export const SITE_URL = 'https://www.praxis-keilberg.de';
export const SITE_NAME = SEO_DE.siteName;
// Optional: absolute URL of an existing, public preview image (recommended 1200×630).
export const SOCIAL_IMAGE = `${SITE_URL}/images/main/background.jpeg`;
export const PAGES = SEO_DE.pages;
export const ALIASES = { '/imprint': '/impressum', '/privacy': '/datenschutzerklaerung' };
export const PUBLIC_PATHS = Object.keys(PAGES);
export const PUBLIC_ENTRY_PATHS = [...PUBLIC_PATHS, ...Object.keys(ALIASES)];
export function normalizePath(path) {
  return (String(path || '/').split(/[?#]/)[0].replace(/\/+$/, '') || '/');
}
export function getSeo(path, publicRoute = false) {
  const normalized = normalizePath(path);
  const canonicalPath = ALIASES[normalized] || normalized;
  const page = publicRoute && Object.hasOwn(PAGES, canonicalPath) ? PAGES[canonicalPath] : null;
  // if (!page) return { title: SITE_NAME, description: '', canonical: null, robots: 'noindex, nofollow', image: null };
  if (!page) return { title: SITE_NAME, description: '', canonical: null, image: null };
  return { ...page, canonical: SITE_URL + canonicalPath, robots: 'index, follow', image: SOCIAL_IMAGE || null };
}
export function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
}
export function seoHead(seo) {
  const meta = (key, value, property = false) => `<meta ${property ? 'property' : 'name'}="${key}" content="${escapeHtml(value)}" data-keilberg-seo>`;
  const tags = [`<title>${escapeHtml(seo.title)}</title>`, meta('robots', seo.robots)];
  if (seo.description) tags.push(meta('description', seo.description));
  if (seo.canonical) {
    tags.push(`<link rel="canonical" href="${escapeHtml(seo.canonical)}" data-keilberg-seo>`);
    for (const [key, value] of Object.entries({ 'og:title': seo.title, 'og:description': seo.description, 'og:type': 'website', 'og:site_name': SITE_NAME, 'og:locale': 'de_DE', 'og:url': seo.canonical })) tags.push(meta(key, value, true));
    tags.push(meta('twitter:card', seo.image ? 'summary_large_image' : 'summary'), meta('twitter:title', seo.title), meta('twitter:description', seo.description));
    if (seo.image) {
      tags.push(
        meta('og:image', seo.image, true),
        meta('og:image:alt', SEO_DE.socialImageAlt, true),
        meta('twitter:image', seo.image),
        meta('twitter:image:alt', SEO_DE.socialImageAlt),
      );
    }
  }
  return tags.join('\n  ');
}
// Called on our own HTML template only; never operates on user-provided HTML.
export function replaceSeoHead(html, seo) {
  return html.replace(/<title\b[^>]*>[\s\S]*?<\/title>/gi, '')
    .replace(/<meta\b[^>]*(?:name|property)\s*=\s*["'](?:description|keywords|robots|og:[^"']*|twitter:[^"']*)["'][^>]*>/gi, '')
    .replace(/<link\b[^>]*rel\s*=\s*["']canonical["'][^>]*>/gi, '')
    .replace(/<\/head>/i, () => `  ${seoHead(seo)}\n</head>`);
}
